import axios from '@/axiosInterceptor';

const state = () => ({
  selectedIdentifier: {},
  allIdentifiers: [],
});

// getters
const getters = {};

// actions
const actions = {
  async getIstypes({ commit }) {
    console.log('getting identifiers is_types');
    try {
      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/identifiers/is_types'
      );
      if (res?.data) {
        commit('setAllIdentifiers', res.data);
      }
      return res;
    } catch (e) {
      if (axios.isAxiosError(e)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setAllIdentifiers(state, data) {
    state.allIdentifiers = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
